export default __webpack_public_path__ + "static/media/appLogin.e6765e1a.jpg";